import { View } from 'react-native'
import styled from 'styled-components'

export const ImagePlaceholder = styled(View)`
  background-color: ${(props) => props.theme.colors[props.disabled ? 'transparent' : 'grayDark']};
  ${(props) => props.width && `width: ${props.width}px`};
  ${(props) => props.height && `height: ${props.height}px`};
`
